<igx-input-group>
  @if (mostrarBtnVistaPrevia) {
    <igx-prefix>
      <button title="{{ titleVistaPrevia | translate }}" igxButton="contained" igxRipple (buttonClick)="evtVistaPrevia.emit()" [disabled]="desactivarBtnVistaPrevia">
        @if (iconVistaPrevia.length > 0) {
          <igx-icon>{{ iconVistaPrevia }}</igx-icon>
        }
      </button>
    </igx-prefix>
  }
  @if (mostrarBtnSubirArchivo) {
    <igx-prefix>
      <button title="{{ titleSubirArchivo | translate }}" igxButton="contained" igxRipple (buttonClick)="fileInput1.click()"
        [disabled]="desactivarBtnSubirArchivo">
        <igx-icon>{{ iconSubirArchivo }}</igx-icon>
        <input #fileInput1 type="file" accept="{{ formatosValidarSubirArchivo }}" (change)="evtSubirArchivo.emit($event)" style="display:none;"/>
      </button>
    </igx-prefix>
  }
  <label igxLabel>{{ etiquetaInput | translate }}:</label>
  <input #libroExcel igxInput [title]="valorInput" [value]="valorInput" type="text" placeholder="{{ placeholderInput | translate }}" [readonly]="readonlyInput"/>
  @if (libroExcel.value && mostrarBtnLimpiar) {
    <igx-suffix (click)="evtLimpiarInput.emit()">
      <button title="{{ 'TOOLTIPS.LIMPIAR_FILTRO' | translate }}" igxIconButton="contained" igxRipple>
        <igx-icon>clear</igx-icon>
      </button>
    </igx-suffix>
  }
  @if (mostrarBtnBajarArchivo) {
    <igx-suffix>
      <button title="{{ titleBajarArchivo | translate }}" igxButton="contained" igxRipple (buttonClick)="evtBajarArchivo.emit()" [disabled]="desactivarBtnBajarArchivo">
        <igx-icon>{{ iconBajarArchivo }}</igx-icon>
      </button>
    </igx-suffix>
  }
  @if (mostrarBtnBuscarLibro) {
    <igx-suffix>
      <button title="{{ titleBuscarDocumento | translate }}" igxButton="contained" igxRipple (buttonClick)="evtObtenerListadoLibro.emit()" [disabled]="desactivarBtnBuscarLibro">
        <igx-icon>{{ iconBuscarLibro }}</igx-icon>
      </button>
    </igx-suffix>
  }
</igx-input-group>
